import styled from 'styled-components';
import {FlexFullGrow, interceptProps, PageContent, ScrollBody} from '@/styled-components';
import {MEDIA_QUERIES, palette} from '@/styles';
import {Button} from '../Button';
import {typographyStyle} from '../Typography';

export const TextFieldLabel = styled('label').withConfig({
  shouldForwardProp: interceptProps(['error']),
})<{error?: boolean}>`
  display: block;
  padding: 0 2px;
  color: ${({error}) => (error ? palette.red400 : palette.gray600)};
  font-weight: 500;
  ${{...typographyStyle.medium14}}
  margin-bottom: 4px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  flex-grow: 1;
  ${FlexFullGrow} {
    min-height: 24px;
  }
`;

export const InlineFieldWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  ${Button} {
    width: 107px;
    flex-basis: 107px;
    flex-shrink: 0;
  }
`;

export const Body = styled(ScrollBody)`
  padding-top: 0;
`;

export const FormWrapper = styled(PageContent)`
  max-width: 380px;
  min-height: 100%;

  ${MEDIA_QUERIES.exclude_mobile} {
    min-height: 450px;
    border-radius: 0px 0px 20px 20px;
    box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.15);
  }
`;

export const Title = styled.div`
  color: ${palette.black};
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;
